import { Component, OnInit } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { CurrencyService } from 'src/app/currency.service';
import { UserService } from 'src/services/user/user.service';
import {
  MatSlideToggleChange,
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';
import { UserPreferencesService } from 'src/app/user-preferences.service';

@Component({
  selector: 'settings-for-preferences',
  standalone: true,
  imports: [
    MatFormField,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
  ],
  templateUrl: './settings-for-preferences.component.html',
  styleUrl: './settings-for-preferences.component.scss',
})
export class SettingsForPreferencesComponent implements OnInit {
  selected: string | null = null;
  defaultOpenAdderOnMobile = false;

  constructor(
    public currencyService: CurrencyService,
    private userService: UserService,
    private userPreferencesService: UserPreferencesService
  ) {
    this.defaultOpenAdderOnMobile =
      this.userPreferencesService.preferences.openMobileAddByDefault;
  }

  ngOnInit(): void {
    this.selected = this.userPreferencesService.preferences.currencyCode;
  }

  setDefaultViewForMobile(change: MatSlideToggleChange) {
    this.userService.update({
      preferences: {
        ...this.userPreferencesService.preferences,
        openMobileAddByDefault: change.checked,
      },
    });
  }

  setCurrency(change: MatSelectChange) {
    if (
      this.currencyService.currencies.some((c) => c.code === change.value) ||
      change.value === null
    ) {
      this.userService.update({
        preferences: {
          ...this.userPreferencesService.preferences,
          currencyCode: change.value,
        },
      });
    }
  }
}
